module.exports = __webpack_public_path__ + "static/assets/25703c6bf7c53a09f7597721184f1dc6.svg";